<main class="login container d-flex align-items-center justify-content-center min-vh-100">
  <div class="km-card login__card w-100">
    <div class="p-4">
      <button
        type="button"
        class="login__tema"
        [attr.aria-pressed]="temaEscuro()"
        [attr.aria-label]="rotuloTema()"
        [title]="rotuloTema()"
        data-testid="login-tema"
        (click)="tema.alternar()"
      >
        <i class="bi" [class.bi-moon-stars]="temaEscuro()" [class.bi-sun]="!temaEscuro()" aria-hidden="true"></i>
      </button>
      <div class="login__marca">
        <span class="login__logo" aria-hidden="true"><i class="bi bi-hdd-network"></i></span>
        <h1 class="login__titulo">Kali Master</h1>
      </div>

      @if (erro(); as mensagem) {
        <div class="alert alert-danger" role="alert" data-testid="login-erro">{{ mensagem }}</div>
      }

      <form [formGroup]="form" (ngSubmit)="entrar()" novalidate>
        <div class="mb-3">
          <label for="login-usuario" class="form-label">Usuário</label>
          <input
            id="login-usuario"
            type="text"
            class="form-control"
            formControlName="nomeUsuario"
            autocomplete="username"
            data-testid="login-usuario"
            [class.is-invalid]="form.controls.nomeUsuario.touched && form.controls.nomeUsuario.invalid"
          />
          <div class="invalid-feedback">Informe o usuário.</div>
        </div>

        <div class="mb-3">
          <label for="login-senha" class="form-label">Senha</label>
          <input
            id="login-senha"
            type="password"
            class="form-control"
            formControlName="senha"
            autocomplete="current-password"
            data-testid="login-senha"
            [class.is-invalid]="form.controls.senha.touched && form.controls.senha.invalid"
          />
          <div class="invalid-feedback">Informe a senha.</div>
        </div>

        <button type="submit" class="btn btn-primary w-100" data-testid="login-submit" [disabled]="carregando()">
          {{ carregando() ? 'Entrando...' : 'Entrar' }}
        </button>
      </form>
    </div>
  </div>
</main>
